import { HttpRequest } from "../../api/core/request/HttpRequest";
import { RequestConstants } from "../../api/core/request/RequestConstants";
import { LangConstants } from "../../game/Constants";
import { LanguageManager } from "../../game/manager/LanguageManager";
import { Dictionary } from "../../util/collection/Dictionary";
import { LangLoaderUtil } from "../../util/lang/LangLoaderUtil";
/**
 * LangRequestJSON.ts
 */
export class LangRequestJSON {
    constructor(baseURL, subPath) {
        this.baseURL = baseURL;
        this.subPath = subPath;
        this.langManager = LanguageManager.getInstance();
        this.locale = this.langManager.getLocale();
        this.lang = new Dictionary();
        this.buildUrl();
    }
    buildUrl() {
        this.url = LangLoaderUtil.getLangOrigin();
        this.url += this.baseURL;
        if (this.subPath) {
            this.url += this.subPath + '/';
        }
        this.url += this.locale.getId() + '.json?' + Date.now();
    }
    load() {
        this.request = new HttpRequest(RequestConstants.GET, this.url);
        this.request.setContentType(RequestConstants.APPLICATION_JSON);
        this.request.setResponseType(RequestConstants.TEXT);
        this.request.onComplete(this.handleComplete, this);
        this.request.onError(this.handleError, this);
        this.request.send();
    }
    handleComplete() {
        let lang = this.request.getJSON();
        console.log("lang in request JSON");
        console.log(lang);
        for (let key in lang) {
            this.processItem(key, lang[key]);
        }
        this.completeHandler.call(this);
    }
    onComplete(handler, scope) {
        this.completeHandler = handler.bind(scope);
    }
    handleError() {
        if (this.locale !== LangConstants.FALLBACK_LANG) {
            console.log(this.locale + " lang load failed. Falling back to " + LangConstants.FALLBACK_LANG);
            this.locale = LangConstants.FALLBACK_LANG;
            this.buildUrl();
            this.load();
        }
        else {
            this.completeHandler.call(this);
        }
    }
    processItem(id, value) {
        this.langManager.add(id, value);
        this.lang.setValue(id, value);
    }
    getLang() {
        return this.lang;
    }
}
//# sourceMappingURL=LangRequestJSON.js.map